import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, Divider } from 'components';

interface ModalDeleteDialogProps {
    height?: number;
    width?: number;
    isOpen: boolean;
    titleText: string;
    onClose: () => void;
    onDelete: () => void;
    confirmText?: string;
    cancelText?: string;
}

export const ModalDeleteDialog: FC<
    PropsWithChildren<ModalDeleteDialogProps>
> = ({
    children,
    isOpen,
    onClose,
    titleText,
    onDelete,
    width,
    height = 200,
    confirmText,
    cancelText
}) => {
    const { t } = useTranslation();

    return (
        <Dialog isOpen={isOpen} onClose={onClose} height={height} width={width}>
            <Dialog.Header title={titleText} onClose={onClose} />
            <Dialog.Body>
                <div>{children}</div>
            </Dialog.Body>
            <Divider orientation="horizontal" spacing={5} />
            <Dialog.Footer>
                <Button onClick={() => onDelete()}>
                    {confirmText || t('general.Delete')}
                </Button>

                <Button type="outlined" onClick={onClose}>
                    {cancelText || t('general.Cancel')}
                </Button>
            </Dialog.Footer>
        </Dialog>
    );
};
